export const initialState = {
    isOpen: true
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'CLOSE_OPEN_IN_APP':
            return {
                ...state,
                isOpen: action.data
            };
        default:
            return state || null;
    }
};
